import React from "react";

import ChatHeader from "../../Components/ChatHeader";
import ChatBody from "../../Components/ChatBody";
import ChatFooter from "../../Components/ChatFooter";
import { Box, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";

const Chat = () => {
  return (
    <Stack
      height={"100%"}
      border={1}
      borderColor={"divider"}
      bgcolor={grey[200]}
    >
      <ChatHeader />

      <Box flexGrow={1} overflow={"auto"}>
        <ChatBody />
      </Box>

      <ChatFooter />
    </Stack>
  );
};

export default Chat;
